import TooltipLink, {
  type TooltipLinkProps,
} from "@/v2-backoffice-client/components/link/TooltipLink"
import { HUBSPOT_CONTACT_BASE_URL } from "@/v2-backoffice-client/constants"

export function getUserHubspotContactUrl(
  externalContactId: string | null | undefined,
) {
  if (!externalContactId) return undefined
  return `${HUBSPOT_CONTACT_BASE_URL}/${externalContactId}`
}

export type UserHubspotButtonProps = Omit<TooltipLinkProps, "to"> & {
  externalContactId: string | null | undefined
}

// Deep link to the user's HubSpot CONTACT record (not the company —
// that's CustomerHubspotButton). Disabled until the CRM sync has linked
// the user to a contact.
function UserHubspotButton(props: UserHubspotButtonProps) {
  const { externalContactId, ...tooltipLinkProps } = props

  return (
    <TooltipLink
      to={getUserHubspotContactUrl(externalContactId)}
      variant="ghost"
      iconSrc="hubspot"
      content={
        externalContactId
          ? "Open the contact in HubSpot"
          : "Not linked to a HubSpot contact yet"
      }
      disabled={!externalContactId}
      {...tooltipLinkProps}
    />
  )
}

export default UserHubspotButton
